(function(){
  var stage=document.querySelector('[data-rack]'); if(!stage) return;
  var rack=stage.closest('.rack')||stage;
  var items=[].slice.call(stage.querySelectorAll('[data-item]'));
  var fine=window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:900px)');
  var mob=window.matchMedia('(max-width:899px)');
  var active=null, timer=null;
  function setDx(el){
    if(!fine.matches){ el.style.setProperty('--dx','0px'); return; }
    var sr=stage.getBoundingClientRect(), slot=el.parentNode.getBoundingClientRect();
    var cx=slot.left+slot.width/2-sr.left;
    var gw=Math.max(250,Math.min(380,Math.min(window.innerWidth*0.31,window.innerHeight*0.46)));
    var L=gw/2+324, Rr=gw/2+215;
    var ideal=(sr.width-L-Rr)/2+L;
    var target=Math.min(Math.max(ideal,L+6),sr.width-Rr-6);
    el.style.setProperty('--dx',(target-cx)+'px');
  }
  function activate(el){
    if(mob.matches || active===el){ return; }
    if(active){ deactivate(active); }
    active=el; setDx(el);
    el.classList.add('is-active'); rack.classList.add('has-active');
    if(fine.matches){ var rt=rack.getBoundingClientRect().top; if(rt>100 || rt<-40){ window.scrollBy({top:rt-96,behavior:'smooth'}); } }
  }
  function deactivate(el){
    el.classList.remove('is-active','is-flipped'); el.style.setProperty('--dx','0px');
    if(active===el){ active=null; }
    if(!active){ rack.classList.remove('has-active'); }
  }
  function later(){ clearTimeout(timer); timer=setTimeout(function(){ if(active && !active._hov && !active.parentNode._hov){ deactivate(active); } },420); }
  items.forEach(function(el){
    var slot=el.parentNode;
    slot.addEventListener('mouseenter',function(){ if(!fine.matches) return; slot._hov=true; activate(el); });
    slot.addEventListener('mouseleave',function(){ slot._hov=false; if(fine.matches) later(); });
    el.addEventListener('mouseenter',function(){ if(!fine.matches) return; el._hov=true; });
    el.addEventListener('mouseleave',function(){ el._hov=false; if(fine.matches) later(); });
    el.addEventListener('focus',function(){ activate(el); });
    el.addEventListener('click',function(e){
      if(e.target.closest('form,select,button,a,label,.rack-info')) return;
      if(mob.matches){ var k=items.indexOf(el); if(!el.classList.contains('is-current')){ goTo(k); } else if(e.target.closest('.swing')){ el.classList.toggle('is-flipped'); } return; }
      if(!el.classList.contains('is-active')){ activate(el); return; }
      if(e.target.closest('.swing')) el.classList.toggle('is-flipped');
    });
    el.addEventListener('keydown',function(e){
      if(e.key==='Enter'||e.key===' '){ if(e.target!==el) return; e.preventDefault(); if(!el.classList.contains('is-active')){ activate(el); } else { el.classList.toggle('is-flipped'); } }
      if(e.key==='Escape'){ deactivate(el); }
    });
    var flip=el.querySelector('[data-flip]'); if(flip) flip.addEventListener('click',function(e){ e.stopPropagation(); el.classList.toggle('is-flipped'); });
    var close=el.querySelector('[data-close]'); if(close) close.addEventListener('click',function(e){ e.stopPropagation(); deactivate(el); });
  });
  document.addEventListener('click',function(e){ if(active && !active.contains(e.target)){ deactivate(active); } });
  [].slice.call(stage.querySelectorAll('.rack-slot')).forEach(function(sl){ sl.addEventListener('animationend',function(e){ if(e.target===sl){ sl.classList.add('done'); } }); });
  var shop=document.querySelector('[data-shop]');
  if(shop){ shop.addEventListener('click',function(){ setTimeout(function(){ if(fine.matches && !active && items[0]){ activate(items[0]); } },650); }); }
  window.addEventListener('resize',function(){ if(active){ setDx(active); } });
  
  // ---- phone: swipe along the rail, one piece at a time ----
  var row=stage.querySelector('.rack-row'), slots=[].slice.call(stage.querySelectorAll('.rack-slot')), cur=-1;
  var nav=rack.querySelector('[data-rack-nav]'), dotsBox=nav&&nav.querySelector('[data-rn-dots]'), prev=nav&&nav.querySelector('[data-rn-prev]'), next=nav&&nav.querySelector('[data-rn-next]'), dots=[];
  if(dotsBox){ slots.forEach(function(s,k){ var b=document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Show piece '+(k+1)); b.addEventListener('click',function(){ goTo(k); }); dotsBox.appendChild(b); dots.push(b); }); }
  function setCur(i){
    if(i===cur) return; cur=i;
    items.forEach(function(it,k){ it.classList.toggle('is-current',k===i); if(k!==i) it.classList.remove('is-flipped'); });
    dots.forEach(function(d,k){ d.classList.toggle('is-on',k===i); });
    if(prev) prev.disabled=(i<=0); if(next) next.disabled=(i>=slots.length-1);
  }
  function goTo(i){
    i=Math.max(0,Math.min(slots.length-1,i)); var s=slots[i];
    row.scrollTo({left:s.offsetLeft-(row.clientWidth-s.offsetWidth)/2,behavior:'smooth'}); setCur(i);
  }
  var ticking=false;
  function onScroll(){
    if(ticking||!mob.matches) return; ticking=true;
    requestAnimationFrame(function(){
      ticking=false; var mid=row.scrollLeft+row.clientWidth/2, best=0, bd=1e9;
      slots.forEach(function(s,k){ var d=Math.abs(s.offsetLeft+s.offsetWidth/2-mid); if(d<bd){ bd=d; best=k; } });
      setCur(best);
    });
  }
  if(row){ row.addEventListener('scroll',onScroll,{passive:true}); }
  if(prev) prev.addEventListener('click',function(){ goTo(cur-1); });
  if(next) next.addEventListener('click',function(){ goTo(cur+1); });
  function syncMode(){
    if(mob.matches){ if(active){ deactivate(active); } cur=-1; setCur(0); if(row) row.scrollLeft=0; }
    else { items.forEach(function(it){ it.classList.remove('is-current'); }); cur=-1; }
  }
  if(mob.addEventListener){ mob.addEventListener('change',syncMode); } else if(mob.addListener){ mob.addListener(syncMode); }
  syncMode();
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ rack.classList.add('is-in'); io.disconnect(); } }); },{threshold:0.01});
    io.observe(stage); setTimeout(function(){ rack.classList.add('is-in'); },2500);
  } else { rack.classList.add('is-in'); }
})();

(function(){
  var stage=document.querySelector('[data-rack]'); if(!stage) return;
  function money(c){ var s=(c/100).toFixed(2); return '$'+s.replace(/\.00$/,''); }
  [].slice.call(stage.querySelectorAll('[data-item]')).forEach(function(el){
    var sel=el.querySelector('select[name=id]'), st=el.querySelector('[data-stock]'), set=el.querySelector('[data-set]');
    if(!sel) return;
    function upd(){
      var o=sel.options[sel.selectedIndex]; if(!o) return;
      var left=parseInt(o.getAttribute('data-left'),10), size=(o.textContent||'').trim().split(/\s|\(/)[0];
      if(st){
        if(isNaN(left)){ st.textContent=''; }
        else if(left<=5){ st.className='rack-stock rack-stock--low'; st.innerHTML='<i></i>Only '+left+' left in size '+size; }
        else { st.className='rack-stock'; st.innerHTML='<i></i>'+left+' left in size '+size; }
      }
      if(set){ var m=o.getAttribute('data-mate'); set.disabled=!m; set.classList.toggle('is-off',!m); set.setAttribute('data-mate-id',m||''); }
    }
    sel.addEventListener('change',upd); upd();
    if(set){
      set.addEventListener('click',function(e){
        e.stopPropagation();
        var mid=set.getAttribute('data-mate-id'); if(!mid) return;
        var o=sel.options[sel.selectedIndex]; set.disabled=true; var a=set.querySelector('.rs-a'), keep=a.innerHTML; a.textContent='Adding\u2026';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+o.value,quantity:1},{id:+mid,quantity:1}]})})
          .then(function(r){ if(!r.ok) throw r; return r.json(); })
          .then(function(){ document.dispatchEvent(new Event('st:cart-added')); })
          .catch(function(){ a.textContent='Try again'; })
          .then(function(){ setTimeout(function(){ a.innerHTML=keep; set.disabled=false; upd(); },1200); });
      });
    }
  });
  // gentle parallax: pieces drift with the cursor
  var fine=window.matchMedia('(hover:hover) and (pointer:fine)');
  stage.addEventListener('mousemove',function(e){ if(!fine.matches) return; var r=stage.getBoundingClientRect(); stage.style.setProperty('--px',((e.clientX-r.left)/r.width-.5).toFixed(3)); });
  stage.addEventListener('mouseleave',function(){ stage.style.setProperty('--px','0'); });
})();

(function(){
  var stage=document.querySelector('[data-rack]'); if(!stage) return;
  [].slice.call(stage.querySelectorAll('[data-item]')).forEach(function(el){
    var info=el.querySelector('.rack-info'), open=el.querySelector('[data-guide]'), close=el.querySelector('[data-guide-close]'), sel=el.querySelector('select[name=id]');
    if(!info||!open||!close) return;
    function mark(){
      var size=sel?(sel.options[sel.selectedIndex].textContent||'').trim().split(/\s|\(/)[0]:'';
      [].slice.call(info.querySelectorAll('.rack-guide [data-s]')).forEach(function(c){ c.classList.toggle('is-me',c.getAttribute('data-s')===size); });
    }
    open.addEventListener('click',function(e){ e.stopPropagation(); mark(); info.classList.add('show-guide'); });
    close.addEventListener('click',function(e){ e.stopPropagation(); info.classList.remove('show-guide'); });
    if(sel) sel.addEventListener('change',mark);
    el.addEventListener('mouseleave',function(){ setTimeout(function(){ if(!el.classList.contains('is-active')) info.classList.remove('show-guide'); },700); });
  });
})();

(function(){
  var stage=document.querySelector('[data-rack]'); if(!stage) return;
  [].slice.call(stage.querySelectorAll('form.p-add')).forEach(function(f){
    var sel=f.querySelector('select[name=id]'); if(!sel||sel.disabled) return;
    var box=document.createElement('div'); box.className='rack-chips'; box.setAttribute('role','radiogroup'); box.setAttribute('aria-label','Size');
    var chips=[];
    [].slice.call(sel.options).forEach(function(o,k){
      var t=(o.textContent||'').trim(), size=t.split(/\s|\(/)[0], left=parseInt(o.getAttribute('data-left'),10);
      var b=document.createElement('button'); b.type='button'; b.className='rack-chip'; b.setAttribute('role','radio');
      b.innerHTML=size+(!isNaN(left)&&left>0&&left<=5?'<small>'+left+' left</small>':'');
      if(o.disabled){ b.disabled=true; }
      b.addEventListener('click',function(e){ e.stopPropagation(); sel.selectedIndex=k; sel.dispatchEvent(new Event('change',{bubbles:true})); sync(); });
      box.appendChild(b); chips.push(b);
    });
    function sync(){ chips.forEach(function(b,k){ var on=(k===sel.selectedIndex); b.classList.toggle('is-on',on); b.setAttribute('aria-checked',on?'true':'false'); }); }
    sel.parentNode.insertBefore(box,sel); f.classList.add('has-chips'); sync();
    sel.addEventListener('change',sync);
  });
})();

(function(){
  var stage=document.querySelector('[data-rack]'), bar=document.querySelector('[data-rack-bar]'); if(!stage||!bar) return;
  var rack=stage.closest('.rack'), mob=window.matchMedia('(max-width:899px)');
  var nm=bar.querySelector('[data-rb-name]'), pr=bar.querySelector('[data-rb-price]'), add=bar.querySelector('[data-rb-add]'), cartBtn=bar.querySelector('[data-rb-cart]');
  function cur(){ return stage.querySelector('.rack-item.is-current'); }
  function sync(){
    var it=cur(); if(!it) return;
    var t=it.querySelector('.rack-title'), col=it.querySelector('.rack-sub span'), p=it.querySelector('.rack-sub b'), sel=it.querySelector('select[name=id]'), f=it.querySelector('form.p-add');
    var size=sel&&sel.selectedOptions[0]?(sel.selectedOptions[0].textContent||'').trim().split(/\s|\(/)[0]:'';
    nm.textContent=(t?t.textContent.replace('Theory 001 ',''):'')+(col?' \u00b7 '+col.textContent:'');
    pr.textContent=(p?p.textContent:'')+(size?' \u00b7 Size '+size:'');
    add.disabled=!(f&&f.querySelector('[type=submit]')&&!f.querySelector('[type=submit]').disabled);
    add.textContent=add.disabled?'Sold out':'Add to cart';
  }
  new MutationObserver(sync).observe(stage,{attributes:true,subtree:true,attributeFilter:['class']});
  stage.addEventListener('change',sync); stage.addEventListener('click',function(){ setTimeout(sync,30); });
  add.addEventListener('click',function(){
    var it=cur(); if(!it) return; var f=it.querySelector('form.p-add'); if(!f) return;
    if(f.requestSubmit){ f.requestSubmit(); } else { f.querySelector('[type=submit]').click(); }
  });
  cartBtn.addEventListener('click',function(){ if(window.STDrawer) window.STDrawer.open(); });
  function vis(on){ bar.classList.toggle('is-on',on&&mob.matches); bar.setAttribute('aria-hidden',(on&&mob.matches)?'false':'true'); }
  function check(){ var r=rack.getBoundingClientRect(); vis(r.top<window.innerHeight-40 && r.bottom>80); }
  window.addEventListener('scroll',check,{passive:true}); window.addEventListener('resize',check); setTimeout(check,400); setTimeout(check,1500); check();
  sync();
})();
